var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#4ADE80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3654 8.23423C17.5154 8.38425 17.5997 8.5877 17.5997 8.79983C17.5997 9.01196 17.5154 9.21541 17.3654 9.36543L10.9654 15.7654C10.8154 15.9154 10.612 15.9997 10.3998 15.9997C10.1877 15.9997 9.98426 15.9154 9.83424 15.7654L6.63424 12.5654C6.48851 12.4145 6.40788 12.2125 6.4097 12.0027C6.41152 11.793 6.49566 11.5923 6.64398 11.444C6.79231 11.2956 6.99296 11.2115 7.20272 11.2097C7.41247 11.2079 7.61456 11.2885 7.76544 11.4342L10.3998 14.0686L16.2342 8.23423C16.3843 8.08425 16.5877 8 16.7998 8C17.012 8 17.2154 8.08425 17.3654 8.23423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/green tick.30ba0e5f0120a68d2a10ce16b439c046.svg";
export { ForwardRef as ReactComponent };